/* "2 pairs" offer money for the shin pad designer, in the customer's own currency. Browser global `JogaPadMoney`,
   CommonJS in Node. Amounts are in hundredths of the currency, as Shopify's Liquid and cart.js give them (also for
   no-decimal currencies: ¥6,400 is 640000). */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.JogaPadMoney = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  var SAVE_BASE = 1000; // the store discount: 10.00 in the base currency, once per order
  var BASE = 'GBP'; // both stores' base currency; the discount is only converted from it

  // Decimals of an ISO currency (EUR 2, JPY 0), from the platform's own currency data.
  function decimals(currency) {
    try { return new Intl.NumberFormat('en', { style: 'currency', currency: currency }).resolvedOptions().maximumFractionDigits; } catch (e) { return 2; }
  }

  // A base-currency amount in the active currency at the storefront's rate, rounded to the currency's smallest unit (as
  // Shopify converts a shipping rate: £4.99 at EUR 1.1848728 = €5.91). null when the rate cannot be trusted.
  function convert(baseCents, currency, base, rate) {
    if (base !== BASE || !currency) return null;
    var r = currency === BASE ? 1 : Number(rate);
    if (!(r > 0) || !isFinite(r)) return null;
    var unit = Math.pow(10, 2 - decimals(currency)); // hundredths per smallest unit (1, or 100 for JPY)
    return Math.round((baseCents * r) / unit) * unit;
  }

  // One pair, two pairs, the struck 2 x price and the saving, all in the active currency. `cents` = one pair's price
  // exactly as the page shows it (Shopify's own converted and rounded price). The saving = 10.00 base x the
  // storefront's rate, rounded to the currency's smallest unit; the base currency keeps rate 1 exactly.
  // Returns null when the maths cannot be trusted (unknown rate, another base currency): the offer then stays off.
  function offer(cents, currency, base, rate) {
    var save = convert(SAVE_BASE, currency, base, rate);
    if (!(cents > 0) || save === null) return null;
    var was = 2 * cents;
    if (!(save > 0) || save >= was) return null;
    return { one: cents, save: save, was: was, two: was - save };
  }

  // Shopify money format (shop.money_format), e.g. "£{{amount}}", "€{{amount_with_comma_separator}}". HTML tags in the
  // format are dropped and entities decoded ("&euro;{{amount}}"). short: drop ".00" from whole amounts, for running
  // copy ("2 pairs for £50"). Styles: [decimals, thousands separator, decimal separator].
  var STYLES = {
    amount: [2, ',', '.'],
    amount_no_decimals: [0, ',', '.'],
    amount_with_comma_separator: [2, '.', ','],
    amount_no_decimals_with_comma_separator: [0, '.', ','],
    amount_with_apostrophe_separator: [2, "'", '.'],
    amount_with_space_separator: [2, ' ', ','],
    amount_with_period_and_space_separator: [2, ' ', '.'],
    amount_no_decimals_with_space_separator: [0, ' ', ','],
  };
  var ENTITIES = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: '\u00a0', euro: '\u20ac', pound: '\u00a3', yen: '\u00a5', cent: '\u00a2', curren: '\u00a4' };
  function decode(text) {
    return text.replace(/&(#x[0-9a-f]+|#\d+|[a-z]+);/gi, function (m, e) {
      if (e[0] !== '#') return ENTITIES[e.toLowerCase()] || m;
      var code = e[1] === 'x' || e[1] === 'X' ? parseInt(e.slice(2), 16) : parseInt(e.slice(1), 10);
      return code > 0 && code < 0x110000 ? String.fromCodePoint(code) : m;
    });
  }
  function format(cents, fmt, short) {
    var text = decode(String(fmt || '{{amount}}').replace(/<[^>]*>/g, ''));
    return text.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, name) {
      var s = STYLES[name] || STYLES.amount;
      var dp = short && cents % 100 === 0 ? 0 : s[0];
      var parts = (cents / 100).toFixed(dp).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, s[1]) + (parts[1] ? s[2] + parts[1] : '');
    }).trim();
  }

  // The offer for this page: rate from Shopify.currency (the storefront's own), only when it is for cfg's currency.
  // Formatted: { one, save, was, two } for price rows, short.* for running copy, and ship = shipBase (a base-currency
  // shipping price, optional) converted. null = offer off.
  function forPage(cents, cfg, shipBase) {
    var sc = typeof Shopify !== 'undefined' && Shopify.currency;
    var rate = sc && sc.active === cfg.currency ? sc.rate : null;
    var o = offer(cents, cfg.currency, cfg.baseCurrency, rate);
    if (!o) return null;
    if (shipBase > 0) o.ship = convert(shipBase, cfg.currency, cfg.baseCurrency, rate);
    var out = { cents: o, short: {} };
    Object.keys(o).forEach(function (k) {
      out[k] = format(o[k], cfg.moneyFormat);
      out.short[k] = format(o[k], cfg.moneyFormat, true);
    });
    return out;
  }

  return { offer: offer, convert: convert, format: format, forPage: forPage, decimals: decimals };
});
